import { Col, Modal, Row } from 'antd';
import * as React from 'react';
import { Provider } from 'unstated';

import GeneralSettingsCol from './GeneralSettingsCol';
import { StateContainer } from './StateContainer';
import ValueSettingsCol from './ValueSettingsCol';
import Form from '../../../components/Form';

interface IVoucherGroupDetailProps {
  domain: string;
  voucherGroup: GQL.IVoucherGroup;
  languages: Array<GQL.ILanguage>;
  onSave: (voucherGroup: GQL.IVoucherGroup) => void;
  onCancel: () => void;
}

interface IVoucherGroupDetailState {
  individualCustomerVoucher: boolean;
}

export default class VoucherGroupDetail extends React.Component<IVoucherGroupDetailProps, IVoucherGroupDetailState> {
  private voucherGroupContainer: StateContainer;

  public constructor(props: IVoucherGroupDetailProps) {
    super(props);
    this.voucherGroupContainer = new StateContainer({
      voucherGroup: props.voucherGroup,
    });

    this.state = {
      individualCustomerVoucher: Array.isArray(props.voucherGroup.customerIds),
    };

    this.save = this.save.bind(this);
  }

  public render() {
    const { voucherGroup } = this.voucherGroupContainer.state;
    return (
      <Provider>
        <Modal
          width={'90%'}
          footer={null}
          title={
            voucherGroup == undefined || voucherGroup.id == undefined
              ? 'New voucher group'
              : `Voucher group ${voucherGroup.title}`
          }
          visible={true}
          // cancelText={'Close'}
          // okText={'Save changes'}
          // onOk={this.save}
          onCancel={() => this.props.onCancel()}
        >
          <Form
            onCancel={() => this.props.onCancel()}
            onSubmit={this.save}
          >
            <Row>
              <Col md={11}>
                <GeneralSettingsCol 
                  container={this.voucherGroupContainer}
                  onIndividualCustomeVoucherSet={() => this.setState({individualCustomerVoucher: (!this.state || this.state && (!this.state.individualCustomerVoucher))})}
                  isIndividualCustomerVoucher={this.state && this.state.individualCustomerVoucher || undefined}
                />
              </Col>
              <Col md={11} offset={1}>
                <ValueSettingsCol
                  domain={this.props.domain}
                  container={this.voucherGroupContainer}
                  isIndividualCustomerVoucher={this.state && this.state.individualCustomerVoucher || undefined}
                />
              </Col>
            </Row>
          </Form>
        </Modal>
      </Provider>
    );
  }

  private async save() {
    const errors = await this.voucherGroupContainer.validate(); // TODO
    let anyError = false;

    for (const key of Object.keys(errors)) {
      if (errors[key] != undefined) {
        anyError = true;
      }
    }

    if (!anyError) {
      const voucherGroup = await this.voucherGroupContainer.getVoucherGroup();

      const data = {
        ...voucherGroup,
        deliveryMethodIds: this.voucherGroupContainer.state.selectedDeliveryMethodIds,
        customerGroupsIds: this.voucherGroupContainer.state.customerGroupsIds,
        includedProductIds: this.voucherGroupContainer.state.includedProductIds,
        giftId: this.voucherGroupContainer.state.giftId || null,
        _isIndividualCustomerVoucher: this.state.individualCustomerVoucher,
      };

      this.props.onSave(data);
    } else {
      console.log('there is error, can not save', errors);
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VoucherGroups/VoucherGroupDetail/VoucherGroupDetail.tsx